
export default obj => JSON.parse(JSON.stringify(obj))
